<template>
    <div class="block-editor whatsapp-business-message">
        <a-spin class="spinner" :spinning="loading">
            <div class="editor-row">
                <div class="editor-row-title">Channel</div>
                <a-select class="classic-new-select" placeholder="Whatsapp Business Channel" v-model="clone.channelId">
                    <a-select-option v-for="channel in businessChannels" :key="channel._id" :value="channel._id">
                        {{ channel.name }}
                    </a-select-option>
                </a-select>
            </div>
            <div class="editor-row" v-if="clone.channelId">
                <div class="editor-row-title">
                    Template
                    <div class="material-icons" @click="previewMode = true">visibility</div>
                </div>
                <a-select
                    class="classic-new-select"
                    placeholder="Whatsapp Business Channel"
                    @change="selectTemplate"
                    :value="selectedTemplateId"
                >
                    <a-select-option v-for="template of templates" :key="template.id" :value="template.id">
                        {{ template.elementName }}
                    </a-select-option>
                </a-select>
            </div>
            <div class="editor-row" v-if="selectedTemplateId">
                <div class="editor-row-title">Phone Number</div>
                <TiptapEditor
                    placeholder="Phone Number"
                    :show-attributes="true"
                    :max-character-count="500"
                    v-model="clone.phoneNumber"
                />
            </div>
            <div class="wpa-variables" v-if="selectedTemplateId && variables.length > 0">
                <div class="editor-row" v-for="(variable, index) of variables">
                    <div class="editor-row-title">Variable (#{{ index + 1 }})</div>
                    <TiptapEditor
                        :placeholder="`Variable (#${index + 1})`"
                        :show-attributes="true"
                        :max-character-count="500"
                        :value="getVariableValue(index)"
                        @change="setVariableValue(index, $event)"
                    />
                </div>
            </div>
            <div
                class="image-picker"
                v-if="clone.template && ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(clone.template.templateType)"
            >
                <div class="editor-row" v-if="useDefault"></div>
                <div class="editor-row" v-else>
                    <div
                        class="editor-row-title"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="'Görseli Özelleştirmek İstiyorsanız.'"
                    >
                        Media
                        <span class="optional">{{ $t("whatsapp_business_api.optional") }}</span>
                        <a-icon type="question-circle" />
                    </div>
                    <div class="media-preview" v-if="media">
                        <div class="media-preview-content">
                            <div class="media-image">
                                <img :src="media.data" alt="" />
                            </div>
                            <div class="media-preview-name">
                                {{ media.name }}
                            </div>
                        </div>
                        <div class="media-preview-delete" @click="deleteMedia">
                            <div class="material-icons">delete</div>
                        </div>
                    </div>
                    <div class="media-drag" v-else>
                        <div class="input">
                            <input type="file" id="media-source" :accept="getAcceptType()" @change="handleFileUpload" />
                        </div>
                        <div class="material-icons">image</div>
                        <div class="content">Click here to upload a picture.</div>
                    </div>
                    <span class="description">
                        <div class="input-warn">
                            <div>
                                <b>Note:</b>Following are the file formats and their respective sizes which are accepted
                                for upload
                            </div>
                            <ul class="list-item">
                                <li>Image: JPEG and PNG (Max size 2 MB)</li>
                                <li>Video: MP4 (Max size 20 MB)</li>
                                <li>Document: (Max size 2 MB)</li>
                            </ul>
                        </div>
                    </span>
                </div>
            </div>
        </a-spin>
        <WhatsappMessagePreview
            :body="getTemplateParameters(clone.template).body"
            :footer="getTemplateParameters(clone.template).footer"
            :header-media-type="getTemplateParameters(clone.template).headerType"
            :header-text="getTemplateParameters(clone.template).headerText"
            :buttons="getTemplateParameters(clone.template).buttons"
            :headerMediaURL="getTemplateParameters(clone.template).headerMediaURL"
            v-if="clone.template"
        />
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";
import { mapActions, mapState } from "vuex";
import TemplateMessageSelector from "../../../../Whatsapp/pages/broadcast/create/TemplateMessageSelector.vue";
import AttributePicker from "../pickers/AttributePicker.vue";
import { uploadAsset } from "../../../../../../api/assetUpload";
import axios from "axios";
import Modal2 from "../../../../../../components/common/Modal2.vue";
import WhatsappMessagePreview from "../../../../WhatsappBusiness/WhatsappMessagePreview.vue";

const log = log2("WhatsappBusinessMessage");
export default {
    name: "WhatsappBusinessMessage",
    components: { WhatsappMessagePreview, Modal2, AttributePicker, TemplateMessageSelector, TiptapEditor },
    props: ["value"],
    data() {
        return {
            loading: false,
            clone: _.cloneDeep(this.value),
            templates: [],
            selectedTemplateId: null,
            variables: [],
            media: null,
            useDefault: false,
            previewMode: false,
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site._id,
            businessChannels: (state) =>
                state.channel.channels.filter((channel) => channel.type === "whatsapp-business-api"),
        }),
    },
    methods: {
        ...mapActions({
            getTemplates: "whatsapp/getTemplates",
        }),
        getTemplateParameters(template) {
            const metaObject = JSON.parse(template.meta);
            const containerMetaObj = JSON.parse(template.containerMeta);

            return {
                headerType: template.templateType, //text|image,
                headerMediaType: template.templateType, //image|video|document|location,
                headerMediaURL: this.media?.asset
                    ? this.media?.asset.url
                    : template.asset &&
                      `https://static.supsis.live/${template.asset.path}${template.asset.id}.${template.asset.ext}`,
                headerText: _.get(containerMetaObj, "header"),
                footer: _.get(containerMetaObj, "footer"),
                body: _.get(metaObject, "example") || metaObject.data,
                buttons: _.get(containerMetaObj, "buttons") || template.buttons,
            };
        },
        getChannelTemplates() {
            if (!this.clone.channelId) return;
            this.loading = true;
            this.getTemplates(this.clone.channelId).then((templates) => {
                this.loading = false;
                this.templates = templates;
                this.media = this.clone.asset && {
                    ...this.clone?.asset,
                    data: this.clone?.asset?.url,
                    asset: this.clone?.asset,
                };
                this.selectedTemplate = this.selectTemplate(this.clone.template?.id);
            });
        },
        selectTemplate(templateId) {
            const template = this.templates.find((t) => t.id === templateId);
            this.selectedTemplateId = templateId;
            this.clone.template = template;
            if (template) {
                this.findBodyVariables(template?.data);
            }
        },
        findBodyVariables(val = "") {
            this.variables = _.uniq(val.match(/{{\d}}/g)).map((x) => "");
            this.clone.params = new Array(this.variables.length).fill("").map((val, index) => {
                return this.clone.params[index] || val;
            });
        },
        getVariableValue(index) {
            return this.clone.params[index] || "";
        },
        setVariableValue(index, val) {
            console.log("setVariableValue", {
                index,
                val,
            });
            this.clone.params = this.clone.params.map((value, paramIndex) => {
                if (index === paramIndex) value = val;
                return value;
            });
        },
        async handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                const imageMime = ["image/jpeg", "image/png"];
                const videoMime = ["video/mp4"];
                const mb = file.size / 1024 / 1024;
                if (imageMime.includes(file.type) && mb >= 2) {
                    this.$message.error("The image could not be uploaded because it is more than 2 MB.", 3);
                    return;
                }
                if (videoMime.includes(file.type) && mb >= 20) {
                    this.$message.error("The video could not be uploaded because it is more than 20 MB.", 3);
                    return;
                }

                this.$message.loading("Image uploading, please wait...", 5);

                let path = `${this.siteId}/whatsapp-business/${this.clone.channelId}/assets/`;
                let imgUploadData = await uploadAsset({
                    path,
                    name: file.name,
                    size: file.size,
                    type: "gupshup-file",
                    mime: file.type,
                    ext: file.name.split(".").pop(),
                });

                await axios({
                    method: imgUploadData.data.method,
                    url: imgUploadData.data.url,
                    data: file,
                    headers: { "Content-Type": file.type },
                });

                this.media = {
                    data: URL.createObjectURL(file),
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    asset: {
                        id: imgUploadData.data.asset.id,
                        url: `https://static.supsis.live/${imgUploadData.data.asset.path}${imgUploadData.data.asset.id}.${imgUploadData.data.asset.ext}`,
                        name: file.name,
                        ext: imgUploadData.data.asset.ext,
                        path: imgUploadData.data.asset.path,
                    },
                };

                this.clone.asset = this.media.asset;
                this.$message.success("Resim başarılı bir şekilde yüklendi.");
            }
        },
        getAcceptType() {
            const templateType = this.clone.template.templateType;
            let types = [];
            if (templateType === "IMAGE") {
                types = _.concat(types, ["image/jpeg", "image/png"]);
            } else if (templateType === "VIDEO") {
                types = _.concat(types, ["video/mp4"]);
            } else if (templateType === "VIDEO") {
                types = _.concat(types, ["application/pdf"]);
            }
            return types.join(" ,");
        },
        deleteMedia() {
            this.media = null;
            this.clone.asset = null;
        },
    },
    mounted() {
        this.getChannelTemplates();
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        "clone.channelId": {
            deep: true,
            handler() {
                this.getChannelTemplates();
            },
        },
    },
};
</script>

<style lang="scss">
.template-preview-modal {
    .custom-modal-header {
        display: none !important;
    }

    .ant-modal-content {
        background: transparent !important;
        box-shadow: none;
    }

    .ant-modal-body {
        background: transparent !important;
    }

    .custom-modal-body {
        background: transparent !important;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.block-editor.whatsapp-business-message {
    padding: 20px;
    display: flex;
    align-items: flex-start;
    gap: 20px;

    .ant-spin-nested-loading {
        width: 300px;
    }

    .ant-spin-container {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .editor-row {
        width: 100%;

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
            display: flex;
            align-items: center;
            gap: 5px;
        }
    }

    .wpa-variables {
        margin-top: 15px;
    }

    .image-picker {
        margin-top: 15px;

        .input-warn {
            background: #fff6e6;
            padding: 20px;

            .list-item {
                padding-left: 15px;
            }
        }

        .media-preview {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .media-preview-content {
                display: flex;
                align-items: center;
                gap: 10px;

                .media-preview-name {
                    font-weight: bold;
                }

                .media-image img {
                    height: 100px;
                }
            }

            .media-preview-delete {
                background: red;
                padding: 5px;
                border-radius: 100%;
                color: white;
                line-height: 0;
            }
        }

        .media-drag {
            display: flex;
            align-items: center;
            flex-direction: column;
            gap: 10px;
            border: 1px solid var(--color-border-default);
            padding: 40px;
            cursor: pointer;
            position: relative;

            .input {
                width: 100%;
                height: 100%;

                input {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    opacity: 0;
                }
            }

            .material-icons {
                font-size: 28px;
            }

            .content {
                font-size: 18px;
                font-weight: bold;
            }
        }
    }

    .classic-new-select {
        width: 100%;
        font-weight: bold;

        [role="combobox"] {
            padding: 4px;
            border: none !important;
            border-radius: 4px !important;
            background-color: #f1f1f1 !important;
        }
    }
}
</style>
